export default {
    yes: "Ja",
    no: "NEIN"
}